import { IDeleteCentroCustoSecundarioUseCase } from "../../../presentation/useCases/delete/delete_centro_custo_secundario_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteCentroCustoSecundarioUseCase
 */

export class DeleteCentroCustoSecundarioUseCase implements IDeleteCentroCustoSecundarioUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async deleteCentroCustoSecundario(idCentroCustoSecundario: number): Promise<void> {
    await this.repository.deleteCentroCustoSecundario(idCentroCustoSecundario);
  }
}